import React from "react";
import PropTypes from "prop-types";
import SummaryBlock from "./SummaryBlock";
import SampleReportGrid from "../details/SampleReportGrid/SampleReportGrid";
import SampleReportGridLink from "../details/SampleReportGrid/SampleReportGridLink";
import SampleReportGridIndicatorsList from "../details/SampleReportGrid/SampleReportGridIndicatorsList";

export const SUMMARY_INDICATORS_ID = "summary-indicators";

const SummaryIndicators = ({ indicators, ...props }) => {
  const grid = {
    fields: [
      {
        heading: "File",
        component: data => (
          <SampleReportGridLink
            data={data}
            section="ticore/indicators"
            {...props}
          />
        ),
        extraPadding: true
      },
      {
        heading: "Description",
        component: data => (
          <SampleReportGridIndicatorsList data={data.indicators} />
        )
      }
    ]
  };

  return (
    <SummaryBlock
      id={SUMMARY_INDICATORS_ID}
      count={indicators.length}
      title="Files With Indicators"
      icon="indicators"
    >
      <SampleReportGrid grid={grid} data={indicators} />
    </SummaryBlock>
  );
};

SummaryIndicators.propTypes = {
  indicators: PropTypes.arrayOf(
    PropTypes.shape({
      event_count: PropTypes.number,
      filename: PropTypes.string,
      indicators: PropTypes.arrayOf(PropTypes.string),
      relationship_id: PropTypes.number,
      sha1: PropTypes.string
    })
  )
};

export default SummaryIndicators;
